import { lazy } from "react";

const InactivesPage = lazy(() => import("./pages/InactivesPage"));

export const inactivesRoutes = [
  { path: "/inactives", element: <InactivesPage /> },
];
